// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TimelineBoxList_wrapper__8dHnE"};